import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import ResultPage from "../ResultPage/ResultPage";
import ResultTwo from "../ResultTwo/ResultTwo";
import Dashboard from "../Dashboard/Dashboard";
import "./ResultAll.css";
import lockIcon from "../../images/lock1.svg";
import girl from "../../images/girl.png";
import star from "../../images/star.png";
import redb from "../../images/red-badge.svg";
import Subscriptions from "../Subscriptions/Subscriptions";
import Strength from "../Strength/Strength";
import ResultChart from "../ResultChart/ResultChart";
import DarkResult from "../DarkResult/DarkResult";
import ResultSlider from "../ResultSlider/ResultSlider";
import { useParams } from "react-router-dom";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import lock from "../../images/lock1.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import loadimg from "../../images/loader_wish.gif";
import SideResult from "../SideArche/SideResult";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ResultPageLast from "../ResultPageLast/ResultPageLast";
import { useLocation } from "react-router-dom";
import CalculateArchetype from "../CalculateArchetype/CalculateArchetype";
import GradientSlider from "../GradientSlider/GradientSlider";
import { Doughnut } from "react-chartjs-2";
import DoughnutLinearChart from "../DoughnutLinearChart/DoughnutLinearChart";
import ky from "../../images/key11.svg";
import sy from "../../images/weight.svg";
import ll from "../../images/yellow-loc.svg";

const Loader = () => (
  <div className="loader-overlay">
    <div className="loader-spinner"></div>
    <p>Loading results...</p>
  </div>
);

function ResultAll({ onLoginChange, globaltest, userdetail, admin }) {
  const subS = false;

  const [IsAdmin, setIsAdmin] = useState(admin);

  const location = useLocation();

  const isCalculatingMode = location.search.includes("calculating");

  const contentRefs = useRef([]);

  const ResultOverview = useRef(null);

  const BadgeEarned = useRef(null);

  const TestDone = useRef(null);

  const ResultLast = useRef(null);

  const observerRef = useRef(null);

  const isManualScrollRef = useRef(false);

  const [FilterSideMenu, setFilterSideMenu] = useState([]);

  const [testData, settestData] = useState([]);

  const [refsReady, setRefsReady] = useState(false);

  const subAd = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink, setTestLink] = useState(null);

  const [TestLink1, setTestLink1] = useState(null);

  const [TestLink2, setTestLink2] = useState(null);

  const [TestLink3, setTestLink3] = useState(null);

  const [TestButtonLabel, setTestButtonLabel] = useState("");

  const [calculationLoaded, setCalculationLoaded] = useState(true);

  const [UnLockModal, setUnLockModal] = useState(false);

  const [RareDate, setRareDate] = useState([]);

  const handleFocus = useCallback((index) => {
    isManualScrollRef.current = true;

    let targetElement = null;

    if (index < contentRefs.current.length) {
      targetElement = contentRefs.current[index];
    }

    if (targetElement) {
      try {
        const elementTop =
          targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementTop - 120;

        window.scrollTo({
          top: Math.max(0, offsetPosition),
          behavior: "smooth",
        });
      } catch (error) {
        console.warn("Scroll with offset failed, using fallback:", error);

        try {
          const elementTop =
            targetElement.getBoundingClientRect().top +
            (window.pageYOffset || document.documentElement.scrollTop);
          const offsetPosition = elementTop - 120;

          if (window.scrollTo) {
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: "smooth",
            });
          } else {
            document.documentElement.scrollTop = Math.max(0, offsetPosition);
          }
        } catch (fallbackError) {
          console.error("All scroll methods failed:", fallbackError);
        }
      }
    }

    setTimeout(() => {
      isManualScrollRef.current = false;
    }, 1500);
  }, []);

  const mapSideMenuToRefs = useCallback(() => {
    if (!FilterSideMenu || !Array.isArray(FilterSideMenu)) return;

    contentRefs.current = [];

    FilterSideMenu.forEach((item, index) => {
      if (item.title && item.title.trim() !== "" && item.id) {
        if (item.id === "result") {
          if (ResultOverview.current) {
            contentRefs.current[index] = ResultOverview.current;
          }
        } else if (item.id === "badge") {
          if (BadgeEarned.current) {
            contentRefs.current[index] = BadgeEarned.current;
          }
        } else if (item.id === "test") {
          if (TestDone.current) {
            contentRefs.current[index] = TestDone.current;
          }
        } else {
          if (ResultLast.current) {
            const strengthSection =
              ResultLast.current.querySelector(`[data-id="${item.id}"]`) ||
              ResultLast.current.querySelector(
                `[data-section-id="${item.id}"]`,
              ) ||
              Array.from(
                ResultLast.current.querySelectorAll(".strg-one h2"),
              ).find((h2) => h2.textContent.trim() === item.title)
                ?.parentElement ||
              Array.from(
                ResultLast.current.querySelectorAll(".strg-one h2"),
              ).find((h2) =>
                h2.textContent
                  .trim()
                  .toLowerCase()
                  .includes(item.title.toLowerCase()),
              )?.parentElement;

            if (strengthSection) {
              contentRefs.current[index] = strengthSection;
            } else {
              const availableSections =
                ResultLast.current.querySelectorAll("[data-id]");

              contentRefs.current[index] = ResultLast.current;
            }
          }
        }
      }
    });

    console.log("Final mapping results:");
    FilterSideMenu.forEach((item, idx) => {
      console.log(
        `${idx}: "${item.title}" (ID: ${item.id}) -> ${
          contentRefs.current[idx] ? "MAPPED" : "NOT MAPPED"
        }`,
      );
    });
  }, [FilterSideMenu]);

  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    // Wait for refs to be ready before setting up observer
    if (!refsReady || !FilterSideMenu?.length || !testData?.data?.length) {
      console.log("Observer setup skipped - refs not ready");
      return;
    }

    console.log("Setting up observer...");

    const setupObserver = () => {
      try {
        const elementsToObserve = contentRefs.current.filter(
          (ref) => ref && ref.nodeType === Node.ELEMENT_NODE,
        );

        if (!elementsToObserve.length) {
          console.warn("No elements to observe yet");
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (isManualScrollRef.current) return;

            let visibleEntry = null;
            let maxRatio = 0;

            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                maxRatio = entry.intersectionRatio;
                visibleEntry = entry;
              }
            });

            if (visibleEntry) {
              try {
                const index = contentRefs.current.findIndex(
                  (ref) => ref === visibleEntry.target,
                );

                if (index >= 0) {
                  setTimeout(() => {
                    if (
                      sideResultRef.current?.setActiveIndex &&
                      !isManualScrollRef.current
                    ) {
                      sideResultRef.current.setActiveIndex(index);
                    }
                  }, 50);
                }
              } catch (error) {
                console.warn("Error processing intersection entry:", error);
              }
            }
          },
          {
            root: null,
            rootMargin: "-20% 0px -60% 0px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0],
          },
        );

        elementsToObserve.forEach((el) => {
          if (el && el.nodeType === Node.ELEMENT_NODE) {
            observer.observe(el);
          }
        });

        observerRef.current = observer;

        console.log(`Observing ${elementsToObserve.length} component elements`);
      } catch (error) {
        console.error("Error setting up intersection observer:", error);
      }
    };

    // Increased delay to ensure DOM is fully rendered
    const timeoutId = setTimeout(setupObserver, 500);

    return () => {
      clearTimeout(timeoutId);
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [refsReady, FilterSideMenu, testData, mapSideMenuToRefs]);

  useEffect(() => {
    const checkRefsReady = () => {
      const allRefsReady =
        ResultOverview.current &&
        TestDone.current &&
        BadgeEarned.current &&
        ResultLast.current;

      if (allRefsReady && !refsReady) {
        console.log("All refs are now ready");
        setRefsReady(true);
      }
    };

    checkRefsReady();

    const timeoutId = setTimeout(checkRefsReady, 100);

    return () => clearTimeout(timeoutId);
  }, [testData, refsReady]);

  useEffect(() => {
    if (!refsReady || !FilterSideMenu?.length || !testData?.data?.length) {
      console.log("Waiting for refs to be ready...", {
        refsReady,
        hasFilterMenu: !!FilterSideMenu?.length,
        hasTestData: !!testData?.data?.length,
      });
      return;
    }

    mapSideMenuToRefs();
  }, [refsReady, FilterSideMenu, testData, mapSideMenuToRefs]);

  // useEffect(() => {
  //   mapSideMenuToRefs();
  // }, [testData, mapSideMenuToRefs]);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const [tests, setTests] = useState([]);

  const { slug, test_slug } = useParams();

  const LocalTest = JSON.parse(localStorage.getItem(slug));

  const [Result, setResult] = useState("");

  const [Demension, setDemension] = useState([]);

  const [Cluster, setCluster] = useState([]);

  const [getBladge, setgetBladge] = useState([]);

  const [HavePastTest, setHavePastTest] = useState(false);

  const token = localStorage.getItem("token");
  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasplan, setHasPlan] = useState({});

  const user = localStorage.getItem("user");
  const navigate = useNavigate();

  const TestSaved = localStorage.getItem(`test_${LocalTest?.test?.id}`);

  const [Opacity, setOpacity] = useState(true);

  const [SubPlan, setSubPlan] = useState({});

  const [Subcription, setSubcription] = useState([]);

  const [TestSubcription, setTestSubcription] = useState([]);

  const [TestResut, setTestResut] = useState([]);

  const [SavedTest, setSavedTest] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [TestLoad, setTestLoad] = useState(true);

  const [resultReady, setResultReady] = useState(false);

  const [PopupContent, setPopupContent] = useState([]);

  const result_letter = useMemo(() => {
    return (
      testData?.data?.map((item) => ({
        final_letter:
          item.letter === "left" ? item.leftletter : item.rightletter,
      })) || []
    );

    if (!testData) {
      testData = {
        test_slug: test_slug,
        slug: slug,
      };
    }
  }, [testData]);

  const [TestInfo, setTestInfo] = useState(() => {
    const saved = localStorage.getItem(`calculation_${slug}`);

    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    if (!SavedTest && !user) {
      settestData(LocalTest);
    }

    if (SavedTest) {
      FetchUserResult().finally(() => setIsLoading(false));
    }
  }, [SavedTest, user]);

  const handleNavigete = (link) => {
    if (link) {
      window.location.href = `/${link}`;
    }
  };

  const handleSub = async (subJson) => {
    try {
      setShowModal(true);

      let subIds = subJson;

      if (typeof subJson === "string") {
        try {
          subIds = JSON.parse(subJson);
        } catch (e) {
          console.error("Invalid JSON string for subIds:", e);
          return;
        }
      }

      if (!Array.isArray(subIds) || subIds.length === 0) {
        console.warn("No valid subscription IDs found:", subIds);
        return;
      }

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  const FetchUserResult = async () => {
    try {
      const response = await fetch(`${END_URL}/user-result`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      const result = data?.data?.result;

      const test = {
        test: {
          id: data.test.id,
          name: data.test.name,
          type: data.test.type,
          slug: data?.test?.slug || "",
          test_slug: data?.data?.test_slug || "",
          test_slug: data?.test?.result_test_name || "",
        },
      };

      const resultdata = {
        data: data?.data?.categoryresult?.map((item, index) => ({
          category_id: item.id,
          left_result: item.left_result,
          leftlabel: item.resultcategory.left_label,
          leftletter: item.resultcategory.leftletter,
          letter: item.letter,
          name: item.name,
          right_result: item.right_result,
          rightlabel: item.resultcategory.right_label,
          rightletter: item.resultcategory.rightletter,
        })),
      };

      const ConvertedtestData = {
        ...resultdata,
        result: result,
        ...test,
      };

      settestData(ConvertedtestData);

      // setRareDate(data?.data?.rarer_percentage);

      setTestLink(data?.free_advertisment_image_link?.slug);

      setTestLink1(data?.paid_test_sub_button_link?.slug);

      // setTestLink1(data?.paid_test_sub_button_link?.slug);

      console.log(testData, "result converted data");
    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  useEffect(() => {
    const SubcriptionDetail = async () => {
      try {
        const response = await axios.get(`${END_URL}/get-subcription`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const reponsedata = response.data;

        setSubcription(reponsedata);
      } catch {
        console.log("some error ");
      }
    };

    SubcriptionDetail();
  }, []);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const response = await axios.post(
          `${END_URL}/check-subcription`,
          testData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        const subscription = response.data.subcription;
        const plan = response.data.test_sub;

        setSubPlan(plan);

        if (subscription) {
          setOpacity(false);
        }

        console.log("Check subscription:", subscription);
        console.log("Plan received from API:", plan);
      } catch (error) {
        console.error("Error checking subscription:", error);
      }
    };

    SaveTest();

    checkSubscription();
  }, [user, token]);

  useEffect(() => {
    const checkSlugSubscription = async () => {
      try {
        const response = await axios.get(
          `${END_URL}/subscription/check/${slug}/${test_slug}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        setHasSubscription(response.data.has_subscription);

        setHasPlan(response.data.plan);
      } catch (error) {
        setHasSubscription(false);
      }
    };

    checkSlugSubscription();
  }, [user, token]);

  useEffect(() => {
    if (Array.isArray(result_letter) && result_letter.length > 0) {
      const finalResult = result_letter
        .map((item) => item.final_letter)
        .join("");

      setResult(finalResult);
    }
  }, [result_letter]);

  useEffect(() => {
    setTestLoad(true);

    axios
      .get(`${END_URL}/tests-list/${slug}`)
      .then((response) => {
        setTests(response.data);

        setTestLoad(false);
      })
      .catch((error) => {
        console.error("Error fetching tests:", error);
      });
  }, []);

  const SaveTest = async () => {
    try {
      const response = await axios.post(
        `${END_URL}/submit/test/${slug}/${test_slug}`,
        LocalTest,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 401 || response.status === 404) {
        handleNavigete("");
        return;
      }

      const testsave = response.data.saved;

      setTestButtonLabel(response.data.subcription_popup?.button_label);

      setResult(response.data.result);

      setSavedTest(testsave);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 404) {
          handleNavigete("");
          return;
        }

        if (error.response.status === 422) {
          console.warn("Result not saved - empty data");
          setSavedTest(false);
          return;
        }
      }

      console.error("Error sending result:", error);
    }
  };

  useEffect(() => {
    if (Result || IsAdmin) {
      setIsLoading(true);

      FetchResultData(Result);
    }
  }, [Result, IsAdmin]);

  useEffect(() => {
    console.log("Demension updated:", Demension);
    if (
      Demension &&
      typeof Demension === "object" &&
      Object.keys(Demension).length > 0
    ) {
      setResultReady(true);
    }
  }, [Demension]);

  const FetchResultData = async (finalResult) => {
    try {
      const LocalTestDone = JSON.parse(localStorage.getItem(slug));

      if (!token && !LocalTestDone) {
        handleNavigete("");
        return;
      }

      const response = await fetch(
        `${END_URL}/result-cluster/${slug}/${test_slug}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            result: finalResult,
            admin: IsAdmin ? true : false,
            categoryresult: LocalTestDone?.data,
          }),
        },
      );

      if (response.status === 401 || response.status === 404) {
        handleNavigete("");
        return;
      }

      const data = await response.json();

      setDemension(data.dimensions);

      setCluster(data.cluster);

      setgetBladge(data.bladge);

      setHavePastTest(data.have_past_test);

      setTestLink(data?.free_advertisment_image_link?.slug);

      setTestLink1(data?.test_sub_button_link_free?.slug);

      setTestLink2(data?.free_test_sub_modal?.slug);

      setTestLink3(data?.unlock_full_result?.slug);

      setPopupContent(data?.popup_content);

      if (data.dimensions?.dimension_content?.length > 0) {
        const headingItems = data.dimensions.dimension_content.filter(
          (item) => item.type === "heading",
        );

        const formattedFilterMenu = [
          { id: "result", title: data.dimensions?.name || "Result Overview" },
        ];

        if (token) {
          formattedFilterMenu.push({ id: "badge", title: "Badges Earned" });
        }

        formattedFilterMenu.push({
          id: "test",
          title: (data?.test?.name || "") + "-" + (data.dimensions?.name || ""),
        });

        headingItems.forEach((item) => {
          if (item.id && item.value) {
            const headingslug = item.value
              .toLowerCase()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]/g, "");

            formattedFilterMenu.push({ id: headingslug, title: item.value });
          }
        });

        setFilterSideMenu(formattedFilterMenu);
      }

      if (data.data && data.data.length > 0) {
        settestData({
          test: data.test,
          data: data.data,
          rarity_percentage: data?.extest?.rarity_percentage,
        });

        setRareDate(data?.extest?.rarer_percentage);
        
      } else {
        // settestData(LocalTest);

        setRareDate(data?.extest?.rarer_percentage);

        if (LocalTest?.data?.length && data?.category?.length) {
          const mergedResults = LocalTest.data.map((localItem) => {
            const matchedCategory = data.category.find(
              (cat) => cat.id === localItem.category_id,
            );

            return {
              ...localItem,
              resultcategory: matchedCategory || null,
            };
          });

          settestData({
            test: data.test,
            data: mergedResults,
            rarity_percentage: data.extest?.rarity_percentage,
          });
        } else {
          settestData({
            test: data.test,
            data: [],
            rarity_percentage: data.extest?.rarity_percentage,
          });
        }
      }
    } catch (error) {
      console.error("Error sending result:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSliderImageLoaded = () => {
    // setResultReady(true);
  };

  const handleNavigate = () => {
    navigate(`/test/${slug}`);
  };

  const testsubscription = testData?.test?.type;

  const typetest =
    testsubscription === "free_test" ? "type_1" : testsubscription;

  const subplan = Subcription?.data?.filter((item) => {
    return item.type === typetest;
  });

  const sideResultRef = useRef(null);

  // small screen side bar script.........

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".menu-toggleBar")
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [tierData, setTierData] = useState([]);

  useEffect(() => {
    const fetchTiers = async () => {
      try {
        const res = await fetch(`${END_URL}/trait-tiers`);

        const data = await res.json();

        setTierData(data);
      } catch (err) {
        console.error("Failed to load tier data", err);
      }
    };

    fetchTiers();
  }, []);

  const [timeoutPassed, setTimeoutPassed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutPassed(true);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (timeoutPassed) {
      navigate(location.pathname, { replace: true });
    }
  }, [timeoutPassed]);

  const dataReady = !isLoading && resultReady && test_slug !== "start";

  const showCalculatingLoader =
    isCalculatingMode && (!calculationLoaded || !(timeoutPassed && dataReady));

  const showNormalLoader =
    !isCalculatingMode && !dataReady && test_slug !== "start";

  if (showCalculatingLoader) {
    return (
      <CalculateArchetype
        token={token}
        slug={slug}
        test_slug={test_slug}
        TestInfo={TestInfo}
      />
    );
  }

  if (showNormalLoader) {
    return (
      <div className="loader-container">
        <img src={loadimg} alt="Loading..." className="loader-gif" />
      </div>
    );
  }

  return (
    <div>
      <div className="result-cont">
        {testData && testData?.data?.length > 0 && (
          <ResultSlider
            dimension={Demension}
            onImageLoadComplete={handleSliderImageLoaded}
          />
        )}

        <div className="container-fluid for-sidebar1">
          <div className="row result-cont-row">
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res sidebar-wrapper">
              {token && (
                <>
                  <Dashboard globaltest={globaltest} />

                  {Demension?.free_advertisment_image && (
                    <div className="adver-title">
                      <a
                        // href={`/${Demension?.free_advertisment_image_link}`}

                        onClick={() =>
                          handleSub(Demension?.free_advertisment_image_link)
                        }
                        className="adver-link"
                      >
                        <div className="dark-adverts">
                          <img
                            loading="lazy"
                            src={`${IMG_URL}/d0/${Demension?.free_advertisment_image}`}
                            alt=""
                          />
                        </div>
                      </a>
                    </div>
                  )}
                </>
              )}

              {Demension?.advertisment_title_free && (
                <h5>{Demension?.advertisment_title_free}</h5>
              )}

              {FilterSideMenu &&
                FilterSideMenu.length > 0 &&
                FilterSideMenu.filter(
                  (item) => item.title !== "" && item.title !== null,
                ).length > 0 && (
                  <SideResult
                    ref={sideResultRef}
                    onMenuItemClick={handleFocus}
                    resultDetails={FilterSideMenu}
                    sideclass=""
                  />
                )}
            </div>

            <div
              className={`col-12 col-sm-12 col-md-9 col-lg-9 ${
                token ? "" : "full-width"
              }`}
            >
              {test_slug !== "start" && (
                <>
                  <span className="menu-toggleBar" onClick={handleToggle}>
                    <FontAwesomeIcon
                      className={`crs ${isOpen ? "show" : "hide"}`}
                      icon={faXmark}
                    />
                    <FontAwesomeIcon
                      className={`mnus ${isOpen ? "hide" : "show"}`}
                      icon={faBars}
                    />
                  </span>

                  <div
                    className={`common-sidebar common-free-result ${isOpen ? "open" : ""}`}
                    ref={sidebarRef}
                  >
                    <div
                      className={`lsit-item-component ${isOpen ? "open" : ""}`}
                    >
                      <SideResult
                        ref={sideResultRef}
                        onMenuItemClick={(...args) => {
                          handleFocus(...args);
                          setIsOpen(false);
                        }}
                        resultDetails={FilterSideMenu}
                        sideclass=""
                      />
                    </div>
                  </div>
                </>
              )}

              {(!testData || testData?.length === 0) && (
                <>
                  <div className="no-login-result resutalljsx">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: tests?.description || "",
                      }}
                    />

                    <div className="no-result-ul">
                      <ul></ul>
                    </div>

                    <a className="button" onClick={handleNavigate}>
                      {TestButtonLabel}
                      <span>
                        {" "}
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                      </span>{" "}
                    </a>
                  </div>
                </>
              )}

              {testData && testData?.data?.length > 0 && (
                <>
                  <div ref={ResultOverview} data-section="result">
                    <ResultPage
                      resultRef={ResultOverview}
                      subs={hasSubscription}
                      Has={hasplan}
                      plan={SubPlan}
                      onLoginChange={onLoginChange}
                      subplan={subplan}
                      token={token}
                      testdata={testData}
                      subcribed={Opacity}
                      result={result_letter}
                      demension={Demension}
                      badge={getBladge}
                      handleSub={handleSub}
                      TestLink={"free_result"}
                    />
                  </div>

                  <div ref={TestDone} data-section="test">
                    <ResultChart
                      resultRef={TestDone}
                      onLoginChange={onLoginChange}
                      subplan={subplan}
                      token={token}
                      result={result_letter}
                      testdata={testData}
                      demension={Demension}
                      opacity={Opacity}
                      past_test={HavePastTest}
                      tierData={tierData}
                      showlock={true}
                      UnLockModal={UnLockModal}
                      setUnLockModal={setUnLockModal}
                      PopupContent={PopupContent}
                    />
                  </div>

                  {Demension?.rarity_common && (
                    <div className="result-newDash2">
                      <div className="result-newDash2-title">
                        <span>
                          <img
                            src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`}
                            alt=""
                          />
                        </span>
                        <div>
                          <h5>
                            {" "}
                            {Demension?.rarity_common?.rarity_section_title}
                          </h5>
                          <p>
                            {
                              Demension?.rarity_common
                                ?.rarity_section_description
                            }
                          </p>
                        </div>
                      </div>

                      <div
                        className="result-newDash2-box"
                        style={{
                          "--color-border":
                            Demension?.rarity_common?.rarity_post_color,
                        }}
                      >
                        <div className="result-newDash2-b1">
                          <div>
                            <span
                              style={{
                                "--color-grade1":
                                  Demension?.rarity_common?.rarity_post_color,
                                "--color-grade2":
                                  Demension?.rarity_common?.rarity_post_color,
                              }}
                            >
                              1
                            </span>

                            <h5>{Demension?.rarity_common?.rare_type_title}</h5>
                          </div>
                          <h3
                            style={{
                              "--color-border":
                                Demension?.rarity_common?.rarity_post_color,
                            }}
                          >
                            {RareDate?.percentage}%
                          </h3>

                          <p
                            style={{
                              "--text-color":
                                Demension?.rarity_common?.rarity_post_color,
                            }}
                          >
                            {Demension?.rarity_common?.post_rarity_percentage?.replace(
                              "{percentage}",
                              RareDate?.percentage || 0,
                            )}
                          </p>

                          {/* <h6>
                                    {" "}
                                    {Demension?.rarity_section?.post_rarity_description}
                                  </h6> */}
                        </div>

                        <div className="result-newDash2-b2 blur_rarity">
                          <div className="result-newDash2-chart">
                            <div class="circular-chart-newDash2">
                              <DoughnutLinearChart
                                bg_color_2={`${Demension?.rarity_common?.rarity_post_color}4D`}
                                gauge_color={
                                  Demension?.rarity_common?.rarity_post_color
                                }
                                value={100 - RareDate?.percentage}
                                gauge_title={
                                  Demension?.rarity_common
                                    ?.graph_post_rarity_title
                                }
                              />
                            </div>
                            <div className="circular-chart-newDash2-bar">
                              <GradientSlider
                                gauge_color1={
                                  Demension?.rarity_common?.rarity_post_color
                                }
                                gauge_color2={
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color
                                }
                                value={RareDate?.percentage}
                              />
                            </div>
                          </div>
                          <div className="result-newDash2-content">
                            <div className="result-newDash2-sub">
                              <div>
                                <span>
                                  <img
                                    src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`}
                                    alt=""
                                  />
                                </span>
                                <h5>
                                  {" "}
                                  {Demension?.rarity_section?.post_rarity_label}
                                </h5>
                              </div>
                              <p>
                                {
                                  Demension?.rarity_section
                                    ?.post_rarity_description
                                }
                              </p>
                            </div>
                          </div>

                        {token ? (

                          <button className="overlay-btn"
                              onClick={() =>
                                handleSub(Demension?.free_test_sub_modal)
                              }
                              style={{'--rarity_result_button_color':Demension?.dimension_color?.rarity_result_button_color,
                                      '--rarity_result_button_color_hover':Demension?.dimension_color?.rarity_result_button_color_hover,
                                      '--luminus_button_color_15': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 15%, white)`,
                                      '--luminus_button_color_25': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 25%, white)`,
                                      '--luminus_button_color_38': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 38%, white)`,
                                      '--luminus_button_color_45': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 45%, white)`,
                                      '--luminus_button_color_50': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 50%, white)`,
                                      '--luminus_button_color_55': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 55%, white)`,
                                      '--luminus_button_color_70': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 70%, white)`,
                                      '--luminus_button_color_85': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 85%, white)`,
                                      '--luminus_button_color_92': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 92%, white)`,
                                      '--luminus_button_color_100': Demension?.dimension_color?.rarity_result_button_color,
                                    }}
                            >
                              <span>{Demension?.rarity_common?.rare_type_button_label}</span>
                              <span>
                                <img src={ll} alt="" />
                              </span>

                          </button>
                        ):(

                            <button className="overlay-btn"
                                onClick={() => onLoginChange(true)}
                                style={{'--rarity_result_button_color':Demension?.dimension_color?.rarity_result_button_color,
                                        '--rarity_result_button_color_hover':Demension?.dimension_color?.rarity_result_button_color_hover,
                                        '--luminus_button_color_15': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 15%, white)`,
                                        '--luminus_button_color_25': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 25%, white)`,
                                        '--luminus_button_color_38': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 38%, white)`,
                                        '--luminus_button_color_45': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 45%, white)`,
                                        '--luminus_button_color_50': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 50%, white)`,
                                        '--luminus_button_color_55': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 55%, white)`,
                                        '--luminus_button_color_70': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 70%, white)`,
                                        '--luminus_button_color_85': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 85%, white)`,
                                        '--luminus_button_color_92': `color-mix(in srgb, ${Demension?.dimension_color?.rarity_result_button_color} 92%, white)`,
                                        '--luminus_button_color_100': Demension?.dimension_color?.rarity_result_button_color,
                                      }}
                              >
                                <span>{Demension?.rarity_common?.rare_type_button_label}</span>
                                <span>
                                  <img src={ll} alt="" />
                                </span>

                            </button>
                        )}
                          
                        </div>

                        {/* <div className="result-newDash2-b1 result-newDash2-b3"></div> */}
                      </div>

                      <div
                        className="result-newDash2-box blur_rarity"
                        style={{
                          "--color-border":
                            Demension?.rarity_common?.rarity_archetype_color,
                        }}
                      >
                        <div className="result-newDash2-b1">
                          <div>
                            <span
                              style={{
                                "--color-grade1":
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color,
                                "--color-grade2":
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color,
                              }}
                            >
                              2
                            </span>

                            <h5>{Demension?.rarity_common?.rarity_title}</h5>
                          </div>

                          <h3
                            style={{
                              "--color-border":
                                Demension?.rarity_common
                                  ?.rarity_archetype_color,
                            }}
                          >
                            {testData?.rarity_percentage}%
                          </h3>

                          <p
                            style={{
                              "--text-color":
                                Demension?.rarity_common
                                  ?.rarity_archetype_color,
                            }}
                          >
                            {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                              "{percentage}",
                              testData?.rarity_percentage || 0,
                            )}
                          </p>

                          {/* <h6 >
                                        {" "}

                                          {Demension?.rarity_section?.archetype_rarity_description}

                                      </h6> */}
                        </div>

                        <div className="result-newDash2-b2 ">
                          <div className="result-newDash2-chart">
                            <div class="circular-chart-newDash2">
                              <DoughnutLinearChart
                                bg_color_2={`${Demension?.rarity_common?.rarity_archetype_color}4D`}
                                gauge_color={
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color
                                }
                                value={100 - testData?.rarity_percentage}
                                gauge_title={
                                  Demension?.rarity_common
                                    ?.graph_archetype_rarity_title
                                }
                                token={token}
                                onLoginChange={onLoginChange}
                              />
                            </div>
                            <div className="circular-chart-newDash2-bar">
                              <GradientSlider
                                gauge_color1={
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color
                                }
                                gauge_color2={
                                  Demension?.rarity_common?.rarity_post_color
                                }
                                value={testData?.rarity_percentage}
                              />
                            </div>

                          </div>
                          <div className="result-newDash2-content">
                            <div className="result-newDash2-sub">
                              <div>
                                <span>
                                  <img
                                    src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`}
                                    alt=""
                                  />
                                </span>

                                <h5>
                                  {" "}
                                  {
                                    Demension?.rarity_section
                                      ?.archetype_rarity_label
                                  }
                                </h5>
                              </div>
                              <p>
                                {
                                  Demension?.rarity_section
                                    ?.archetype_rarity_description
                                }
                              </p>
                            </div>
                          </div>

                          {token ? (
                              <button className="overlay-btn"
                                    onClick={() =>
                                      handleSub(Demension?.free_test_sub_modal)
                                    }
                                    style={{'--archetype_result_button_color':Demension?.dimension_color?.archetype_result_button_color ,
                                            '--archetype_result_button_color_hover':Demension?.dimension_color?.archetype_result_button_color_hover,
                                            '--luminus_button_color_15': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 15%, white)`,
                                            '--luminus_button_color_25': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 25%, white)`,
                                            '--luminus_button_color_38': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 38%, white)`,
                                            '--luminus_button_color_45': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 45%, white)`,
                                            '--luminus_button_color_50': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 50%, white)`,
                                            '--luminus_button_color_55': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 55%, white)`,
                                            '--luminus_button_color_70': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 70%, white)`,
                                            '--luminus_button_color_85': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 85%, white)`,
                                            '--luminus_button_color_92': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 92%, white)`,
                                            '--luminus_button_color_100': Demension?.dimension_color?.archetype_result_button_color,
                                          }}
                                  >

                                {" "}
                                <span>{Demension?.rarity_common?.rarity_arche_type_button_label}</span>
                                <span>
                                  <img src={ll} alt="" />
                                </span>{" "}
                              </button>

                            ):(
                                <button className="overlay-btn"
                                     onClick={() => onLoginChange(true)}
                                     style={{'--archetype_result_button_color':Demension?.dimension_color?.archetype_result_button_color,
                                              '--archetype_result_button_color_hover':Demension?.dimension_color?.archetype_result_button_color_hover,
                                              '--luminus_button_color_15': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 15%, white)`,
                                              '--luminus_button_color_25': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 25%, white)`,
                                              '--luminus_button_color_38': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 38%, white)`,
                                              '--luminus_button_color_45': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 45%, white)`,
                                              '--luminus_button_color_50': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 50%, white)`,
                                              '--luminus_button_color_55': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 55%, white)`,
                                              '--luminus_button_color_70': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 70%, white)`,
                                              '--luminus_button_color_85': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 85%, white)`,
                                              '--luminus_button_color_92': `color-mix(in srgb, ${Demension?.dimension_color?.archetype_result_button_color} 92%, white)`,
                                              '--luminus_button_color_100': Demension?.dimension_color?.archetype_result_button_color,
                                            }}
                                    >

                                  {" "}
                                  <span>{Demension?.rarity_common?.rarity_arche_type_button_label}</span>
                                  <span>
                                    <img src={ll} alt="" />
                                  </span>{" "}
                                </button>
                              
                            )}
                        </div>

                        {/* <div className="result-newDash2-b1 result-newDash2-b3"></div> */}
                      </div>

                      <div className="result-newDash2-weight">
                        <div className="result-newDash2-weight-left">
                          <span>
                            <img
                              src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`}
                              alt=""
                            />
                          </span>

                          <h6>
                            {" "}
                            {Demension?.rarity_common?.key_diffence_type}
                          </h6>
                        </div>

                        <div className="result-newDash2-weight-right">
                          <ul>
                            <li
                              style={{
                                "--color-two":
                                  Demension?.rarity_common?.rarity_post_color,
                              }}
                            >
                              {Demension?.rarity_common?.key_term_1}{" "}
                            </li>
                            <li
                              style={{
                                "--color-two":
                                  Demension?.rarity_common
                                    ?.rarity_archetype_color,
                              }}
                            >
                              {Demension?.rarity_common?.key_term_2}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {RareDate && (
                    <div className="result-newDash">
                      <div className="result-newDash-outer">
                        <div className="result-newDash-title">
                          <span>{Demension?.rare_type_title}</span>

                          <h5>
                            {RareDate?.heading?.replace(
                              "{percentage}",
                              RareDate?.percentage,
                            )}
                          </h5>
                          <p>{RareDate?.description}</p>
                        </div>

                        <div className="result-newDash-value-box">
                          <div className="result-newDash-value-box-inner">
                            <div className="per-value">
                              <p>Rarity Score</p>
                              <h2>{RareDate?.percentage}%</h2>
                            </div>
                            <button>{RareDate?.name}</button>
                          </div>

                          <div className="result-newDash-bar">
                            <div class="two-card-progress">
                              <div class="progress-bar-fill-repeat-title">
                                <span>
                                  <span>{RareDate?.extreme_type}</span>
                                </span>
                                <div>Top {100 - RareDate?.percentage}%</div>
                              </div>
                              <div class="two-card-progress2">
                                <div
                                  class="progress-bar-fill-repeat"
                                  style={{
                                    background: `linear-gradient(
                                      90deg,
                                      #8c30a8b5 ${100 - RareDate?.percentage}%,
                                      #cda632 40%
                                    )`,
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="result-newDash-textDiv">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: RareDate?.matters,
                            }}
                          />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: RareDate?.fallback,
                            }}
                          />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: RareDate?.dev_note,
                            }}
                          />
                        </div>

                        <div className="result-newDash-textDiv rariry-result">
                          {Demension?.rarity_name && (
                            <div className="rarity-des result-newDash-title">
                              <span>{Demension?.rarity_title}</span>
                              <h5>
                                {Demension?.rarity_name?.replace(
                                  "{rarity}",
                                  testData?.rarity_percentage,
                                )}
                              </h5>
                              <p>{Demension?.rarity_description}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )} */}

                  <div
                    ref={BadgeEarned}
                    data-section="badge"
                    style={!token ? { display: "none" } : {}}
                  >
                    {token && <ResultTwo test_id={testData?.test?.id} />}
                  </div>

                  <div ref={ResultLast} data-section="strength">
                    <Strength
                      result={FilterSideMenu.filter(
                        (item) => typeof item.id === "number",
                      )}
                      resultRef={contentRefs}
                      onLoginChange={onLoginChange}
                      subs={hasSubscription}
                      Has={hasplan}
                      plan={SubPlan}
                      ResultLast={ResultLast}
                      subplan={subplan}
                      token={token}
                      testdata={testData}
                      subcribed={hasSubscription}
                      badge={getBladge}
                      demension={Demension}
                      userdetail={userdetail}
                      TestLink={TestLink2}
                      handleSub={handleSub}
                      PopupContent={PopupContent}
                      UnLockModal={UnLockModal}
                      setUnLockModal={setUnLockModal}
                    />
                  </div>

                  <div className="free-unpaid-res">
                    {ResultLast && (
                      <ResultPageLast
                        userdetail={userdetail}
                        TestLink={TestLink1}
                        type="free_result"
                        onLoginChange={onLoginChange}
                        token={token}
                        slug={slug}
                        demension={Demension}
                      />
                    )}
                  </div>
                </>
              )}

              {ShowModal && (
                <div
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                    subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                >
                  <div className="newdashpop-inner">
                    <div className="newdashpop-container">
                      <button
                        className="newdashpop-close"
                        onClick={() => setShowModal(false)}
                      >
                        &times;
                      </button>

                      <div className="conent-pop">
                        <Subscriptions
                          subs={subAd}
                          userdetail={{ ...userdetail, user_all_access: "0" }}
                          force_to_disable={false}
                          Subcription={subscription}
                          onLoginChange={onLoginChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultAll;
